import { BookingDraft } from '@/scopes/checkout/domain/types'
import {
  AvailableRooms,
  UpdateRoomSelectionPayload,
} from '@/scopes/checkout/groups/domain/types/availableRooms'
import { produce } from 'immer'

export function updateRoomInAvailableRooms(payload: UpdateRoomSelectionPayload) {
  return produce((currentAvailableRooms: AvailableRooms) => {
    if (!payload.name || !payload.type || !payload.roomId)
      return

    const roomType = currentAvailableRooms?.roomTypes?.[payload.type]

    currentAvailableRooms.rooms = {
      ...currentAvailableRooms.rooms,
      [payload.roomId]: {
        name: payload.name,
        roomId: payload.roomId || '',
        description: roomType?.description || '',
        isFull: false,
        availableBedsAmount: roomType ? Math.max(0, roomType.totalBedsAmount - 1) : 0,
        totalBedsAmount: roomType?.totalBedsAmount || 0,
        roomType: payload.type,
      },
    }
  })
}

export function updateRoomInBookingDraft(payload: UpdateRoomSelectionPayload) {
  return produce((currentBookingDraft: BookingDraft | undefined) => {
    if (!currentBookingDraft)
      return

    if (!currentBookingDraft.groupInformation)
      return
    currentBookingDraft.groupInformation = {
      ...currentBookingDraft?.groupInformation,
      selectedRoom: {
        ...currentBookingDraft.groupInformation?.selectedRoom,
        method: payload.assignationMethod,
        name: payload.name || undefined,
        type: payload.type || undefined,
        isNewRoom: payload.isNewRoom || false,
        pinCode: payload.pinCode || undefined,
        roomId: payload.roomId || '',
      },
    }
  })
}
